import { AppSettings } from "appSettings/appSettings.dev";
import { Business, ContractType, Job, BusinessUnitsType } from "../types";
import { BaseService } from "./BaseService";

class BusinessCoreService {
  private baseService: BaseService;
  constructor() {
    this.baseService = new BaseService(AppSettings.apiURL);
  }

  async getBusinesses(): Promise<Business[]> {
    const response = await this.baseService.get<Business[]>("BusinessCore/GetBusinesses");
    return response.data;
  }

  async getJobs(): Promise<Job[]> {
    const response = await this.baseService.get<Job[]>("BusinessCore/GetJobs");
    return response.data;
  }

  async getContractTypes(): Promise<ContractType[]> {
    const response = await this.baseService.get<ContractType[]>("BusinessCore/GetContractTypes");
    return response.data;
  }

  async getBusinessUnitsType(): Promise<BusinessUnitsType[]> {
    const response = await this.baseService.get<BusinessUnitsType[]>("BusinessCore/GetBusinessUnitsTypes");
    return response.data;
  }
}

export const businessCoreService = new BusinessCoreService();
